(function () {
  'use strict';

  const SLIDE_SEL  = '.product-images__slide--video';
  const VIDEO_SEL  = 'video';
  const POSTER_BTN = '.play-pause-button';
  const ACTIVE_CLS = 'is-active';
  const INITED     = 'data-mrk-inited';

  /* ── SVG icons ──────────────────────────────────────────────────────── */
  const SVG = {
    pause: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
              <rect x="5" y="3" width="4" height="18" rx="1.2"/>
              <rect x="15" y="3" width="4" height="18" rx="1.2"/>
            </svg>`,
    play:  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
              <polygon points="5,3 20,12 5,21"/>
            </svg>`,
    muted: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M3 9v6h4l5 5V4L7 9H3z"/>
              <line x1="17" y1="9" x2="23" y2="15" stroke-width="2" stroke-linecap="round" fill="none"/>
              <line x1="23" y1="9" x2="17" y2="15" stroke-width="2" stroke-linecap="round" fill="none"/>
            </svg>`,
    sound: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M3 9v6h4l5 5V4L7 9H3z"/>
              <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z" fill="currentColor"/>
              <path d="M19 12c0 2.89-1.58 5.41-3.91 6.77l1.46 1.46C19.11 18.48 21 15.43 21 12c0-3.43-1.89-6.48-4.46-8.23L15.08 5.23C17.42 6.59 19 9.11 19 12z" fill="currentColor"/>
            </svg>`
  };

  /* ── Build the custom control bar ───────────────────────────────────── */
  function buildControls() {
    const bar = document.createElement('div');
    bar.className = 'mrk-vc-bar';

    const pp = document.createElement('button');
    pp.type = 'button';
    pp.className = 'mrk-vc-btn mrk-vc-pp';
    pp.setAttribute('aria-label', 'Pause video');
    pp.innerHTML = SVG.pause + SVG.play;

    const mu = document.createElement('button');
    mu.type = 'button';
    mu.className = 'mrk-vc-btn mrk-vc-mu';
    mu.setAttribute('aria-label', 'Unmute video');
    mu.innerHTML = SVG.muted + SVG.sound;

    bar.appendChild(pp);
    bar.appendChild(mu);
    return { bar, pp, mu };
  }

  /* ── Wire up one video slide ─────────────────────────────────────────── */
  function initSlide(slide) {
    if (slide.hasAttribute(INITED)) return;
    slide.setAttribute(INITED, '1');

    const video = slide.querySelector(VIDEO_SEL);
    if (!video) return;

    /* 1. Override video element attributes */
    video.removeAttribute('controls');
    video.controls    = false;
    video.muted       = true;
    video.loop        = true;
    /* Geen autoplay (Dave, 3 nov): het autoplay-attribuut liet de browser elke galerijvideo
       bij het openen volledig bufferen, ook buiten beeld (tot 15 MB op mobiel). Afspelen
       gebeurt hieronder pas als de slide actief of zichtbaar is. */
    video.autoplay    = false;
    video.removeAttribute('autoplay');
    video.preload     = 'none';
    video.playsInline = true;

    /* 2. Hide the theme's deferred poster button */
    const posterBtn = slide.querySelector(POSTER_BTN);
    if (posterBtn) posterBtn.style.display = 'none';

    /* 3. Inject custom controls */
    const mediaWrap = slide.querySelector('.product-single__media-native-video') || slide;
    mediaWrap.style.position = 'relative';
    const { bar, pp, mu } = buildControls();
    mediaWrap.appendChild(bar);

    /* helper: buffer eerst ('auto'), dan afspelen */
    const tryPlay = () => { video.preload = 'auto'; return video.play().catch(() => {}); };

    /* User manually paused? Track it so IntersectionObserver respects it */
    let userPaused = false;

    /* 4. Play/Pause button */
    pp.addEventListener('click', () => {
      if (video.paused) {
        userPaused = false;
        tryPlay();
      } else {
        userPaused = true;
        video.pause();
      }
    });
    video.addEventListener('play',  () => {
      pp.setAttribute('data-state', 'playing');
      pp.setAttribute('aria-label', 'Pause video');
    });
    video.addEventListener('pause', () => {
      pp.setAttribute('data-state', 'paused');
      pp.setAttribute('aria-label', 'Play video');
    });

    /* 5. Mute/Unmute button */
    mu.addEventListener('click', () => { video.muted = !video.muted; });
    const syncMute = () => {
      mu.setAttribute('data-state', video.muted ? 'muted' : 'sound');
      mu.setAttribute('aria-label',  video.muted ? 'Unmute video' : 'Mute video');
    };
    video.addEventListener('volumechange', syncMute);
    syncMute();

    /* ── A) IntersectionObserver: play on scroll-into-view ── */
    /* Ratio in plaats van isIntersecting: die is al true bij 1px in beeld, en op mobiel
       steekt de videoslide 30px naast de foto uit, waardoor hij direct ging laden. */
    /* Voordat Flickity de slider opbouwt staan de slides even onder elkaar volledig in
       beeld (gemeten op iPhone: 2,3 s na laden). Meldingen uit die fase negeren, anders
       starten alle video's tegelijk. */
    const sliderKlaar = () => {
      const s = slide.closest('.mrk-top-slider, .flickity-slider, [class*="flickity"]');
      return !s || !!slide.closest('.flickity-enabled');
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!sliderKlaar()) return;
        if (entry.intersectionRatio >= 0.5) {
          if (!userPaused) tryPlay();
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, 0.5] });
    io.observe(slide);

    /* ── B) MutationObserver: play/pause on slider active-class change ── */
    const mo = new MutationObserver(() => {
      if (slide.classList.contains(ACTIVE_CLS)) {
        if (!userPaused) tryPlay();
      } else {
        video.pause();
      }
    });
    mo.observe(slide, { attributes: true, attributeFilter: ['class'] });

    /* Immediate check if already active (mobile slider on load) */
    if (slide.classList.contains(ACTIVE_CLS) && sliderKlaar() && !userPaused) {
      tryPlay();
    }
  }

  /* ── Scan DOM for all video slides ──────────────────────────────────── */
  function scan() {
    document.querySelectorAll(SLIDE_SEL).forEach(initSlide);
    warmEerste();
  }

  /* ── Eerste galerijvideo voorrang geven ─────────────────────────────── */
  /* Na het laden van de pagina alleen de metadata (eerste bytes); zodra iemand de
     galerij aanraakt of erdoor scrollt, gaat hij bufferen zodat hij direct speelt als
     zijn slide in beeld komt. De andere video's laden pas als hun slide actief is. */
  let warmGezet = false;
  function warmEerste() {
    if (warmGezet) return;
    const eerste = document.querySelector(SLIDE_SEL + ' ' + VIDEO_SEL);
    if (!eerste) return;
    warmGezet = true;
    const bespaar = navigator.connection && navigator.connection.saveData;
    const metadata = () => { if (eerste.preload === 'none') eerste.preload = 'metadata'; };
    const buffer = () => { if (!bespaar && eerste.preload !== 'auto') eerste.preload = 'auto'; };
    const naLaden = () => ('requestIdleCallback' in window ? requestIdleCallback(metadata, { timeout: 3000 }) : setTimeout(metadata, 1500));
    document.readyState === 'complete' ? naLaden() : window.addEventListener('load', naLaden, { once: true });
    const galerij = eerste.closest('.product-images, .product-images-container, [class*="product-images"]') || eerste.closest('section') || document;
    ['pointerdown', 'touchstart', 'scroll', 'wheel'].forEach((t) => {
      galerij.addEventListener(t, buffer, { once: true, passive: true, capture: true });
    });
  }

  /* ── Boot ────────────────────────────────────────────────────────────── */
  function boot() {
    scan();

    /* Watch for Shopify re-renders (variant switches, section reload) */
    new MutationObserver((mutations) => {
      let changed = false;
      mutations.forEach(m => { if (m.addedNodes.length) changed = true; });
      if (changed) scan();
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();
